/**
 * Check if the page has google Scripts
 * @returns {Boolean} True if it has
 */
export function hasGoogleScripts(): boolean {
    const scripts = document.getElementsByTagName('script');

    return Array.from(scripts).some(
        (script: HTMLScriptElement) => [
            // 'google', This could possable trigger the polling on font loading
            'google-analytics',
            'googletagmanager',
        ].some((v) => script.src.includes(v)),
    );
}
